import classNames from "classnames";
import styles from "./style.module.scss";
import CustomModal from "shared/components/common/customModal";
import { Icons } from "assets";
import CustomButton from "shared/components/common/customButton";
import { useState } from "react";
import CustomInput from "shared/components/common/customInput";
import { FlagUserService, UnFlagUserService } from "shared/services/users";
import { toastMessage } from "shared/components/common/toast";
import { handleErrors } from "shared/utils/helper";

interface Props extends ModalProps {
  user: any;
  handleGetAllUsers: (page: number) => void;
  currentPage: number;
}

const FlagUserModal = ({
  user,
  show,
  handleClose,
  handleGetAllUsers,
  currentPage,
}: Props) => {
  const [reason, setReason] = useState("");
  const [suspendLoading, setSuspendLoading] = useState(false);

  const handleFlagUser = async () => {
    if (!reason && !user?.flagged) {
      toastMessage("error", "Please enter a reason");
      return;
    }
    if (!user) return;
    setSuspendLoading(true);
    if (user?.flagged) {
      UnFlagUserService(user?.id)
        .then(({ data, status }) => {
          if (status) {
            toastMessage("success", "User Unflagged Successfully");
            handleGetAllUsers(currentPage);
            handleClose();
          }
        })
        .catch((error) => {
          handleErrors(error);
        })
        .finally(() => {
          setSuspendLoading(false);
        });
    } else {
      FlagUserService(user?.id, {
        flagged_comment: reason,
      })
        .then(({ data, status }) => {
          if (status) {
            toastMessage("success", "User Flagged Successfully");
            handleGetAllUsers(currentPage);
            handleClose();
          }
        })
        .catch((error) => {
          handleErrors(error);
        })
        .finally(() => {
          setSuspendLoading(false);
        });
    }
  };

  return show ? (
    <CustomModal>
      <div className={classNames(styles.contentContainer)}>
        <div className="flex items-center justify-end px-4 mt-4 mb-3">
          <div
            className={classNames(styles.crossContainer)}
            onClick={() => {
              if (!suspendLoading) {
                handleClose();
              }
            }}
          >
            <Icons.Cross />
          </div>
        </div>
        <div
          className={classNames(styles.modalBody, "w-full flex flex-col gap-4")}
        >
          <div className="flex flex-col gap-2 mb-4">
            <h6>Are you sure?</h6>
            <p>Are you sure you want to proceed?</p>
          </div>
          {!user?.flagged && (
            <CustomInput
              label="Reason"
              placeholder="Enter reason"
              value={reason}
              onChange={(e) => setReason(e.currentTarget.value)}
            />
          )}
          <div className="flex items-center w-full justify-between gap-4">
            <CustomButton
              title={"Not Now"}
              containerStyle={styles.defaultButton}
              onClick={handleClose}
              disabled={suspendLoading}
              style={{ width: "100%" }}
            />
            <CustomButton
              title={"Yes, Confirm"}
              containerStyle={classNames(styles.actionButton, "bg-red")}
              onClick={handleFlagUser}
              loading={suspendLoading}
              disabled={suspendLoading}
              style={{ width: "100%" }}
            />
          </div>
        </div>
      </div>
    </CustomModal>
  ) : null;
};

export default FlagUserModal;
